import { render, staticRenderFns } from "./InlineButton.vue?vue&type=template&id=621be735&"
import script from "./InlineButton.vue?vue&type=script&lang=js&"
export * from "./InlineButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports